export function combineNumberTaskExecutions(
  taskExecutions: {
    goals: {
      greaterThan: number | null;
      lessThan: number | null;
    } | null;
    numberValue: number | null;
  }[]
) {
  return taskExecutions.reduce<{
    numberOfRest: number;
    numberValue: null | number;
    goals: { lessThan: null | number; greaterThan: null | number };
  }>(
    (prev, curr) => ({
      numberOfRest: prev.numberOfRest + 1,

      numberValue:
        prev.numberValue === null && curr.numberValue === null
          ? null
          : (prev.numberValue ?? 0) + (curr.numberValue ?? 0),
      goals: {
        lessThan:
          prev.goals.lessThan === null &&
          (curr.goals?.lessThan ?? null) === null
            ? null
            : (prev.goals.lessThan ?? 0) + (curr.goals?.lessThan ?? 0),
        greaterThan:
          prev.goals.greaterThan === null &&
          (curr.goals?.greaterThan ?? null) === null
            ? null
            : (prev.goals.greaterThan ?? 0) + (curr.goals?.greaterThan ?? 0),
      },
    }),
    {
      numberOfRest: 0,
      numberValue: null,

      goals: { lessThan: null, greaterThan: null },
    }
  );
}
